import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[arabicToEnglish]'
})
export class ArabicToEnglishDirective {
  private easternToWesternMap: { [key: string]: string } = {
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
  };

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputEl = this.el.nativeElement;
    const value = inputEl.value;
    // only convert if there's at least one Arabic digit
    if (!/[٠-٩]/.test(value)) return;

    const converted = this.convertArabicToEnglish(value);
    if (converted !== value) {
      inputEl.value = converted;
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') || '';
    const converted = this.convertArabicToEnglish(clipboardData);

    const inputEl = this.el.nativeElement;
    const maxLength = inputEl.maxLength > 0 ? inputEl.maxLength : Infinity;
    const start = inputEl.selectionStart || 0;
    const end = inputEl.selectionEnd || 0;
    const current = inputEl.value;

    const combined = current.substring(0, start) + converted + current.substring(end);
    const trimmed = combined.slice(0, maxLength);

    inputEl.value = trimmed;
    const pos = Math.min(start + converted.length, maxLength);
    inputEl.setSelectionRange(pos, pos);
    inputEl.dispatchEvent(new Event('input', { bubbles: true }));
  }

  private convertArabicToEnglish(input: string): string {
    return input.replace(/[٠-٩]/g, d => this.easternToWesternMap[d] || d);
  }
}
